import { render } from "./customer-dispatches.vue?vue&type=template&id=fb9fb1c4&scoped=true"
import script from "./customer-dispatches.vue?vue&type=script&lang=js"
export * from "./customer-dispatches.vue?vue&type=script&lang=js"

import "./customer-dispatches.vue?vue&type=style&index=0&id=fb9fb1c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb9fb1c4"]])

export default __exports__